import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Button from '../../../_shared/components/Button';

/**
 * Variant Definitions
 */
const StyledFormItemLabelVariants = {
  error: css`
    color: ${({ theme }) => theme.COLORS.ERROR};
  `
};

const StyledFormItemInputVariants = {
  error: css`
    border: 2px solid ${({ theme }) => theme.COLORS.ERROR};
  `
};

const StyledFormItemVariants = {
  fr: css`
    height: 100px;
  `
};

export const StyledBidForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 18px 0;
`;

export const BiddingContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledInputs = styled.div`
  margin-right: 24px;
`;

const StyledFormItem = styled.div`
  height: 58px;
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    margin-bottom: 24px;
  }

  ${({ variant }) => StyledFormItemVariants[variant]}
`;

StyledFormItem.Label = styled.label`
  font-size: 14px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-bottom: 6px;

  ${({ variant }) => StyledFormItemLabelVariants[variant]}
`;

StyledFormItem.Wrapper = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
`;

StyledFormItem.Input = styled.input`
  width: 216px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px;
  padding: 12px;

  ${({ variant }) => StyledFormItemInputVariants[variant]}

  &:disabled {
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }
`;

export { StyledFormItem };

export const StyledControls = styled.div``;

export const StyledProxyDescription = styled.div`
  font-size: 14px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  line-height: 17px;
  margin-right: -8px;
`;

export const StyledEditButton = styled(Button.Transparent)`
  display: inline-block;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  text-decoration-line: underline;
`;

StyledFormItemLabelVariants.propTypes = {
  variant: PropTypes.oneOf(['error'])
};

StyledFormItemLabelVariants.defaultProps = {
  variant: undefined
};

StyledFormItemInputVariants.propTypes = {
  variant: PropTypes.oneOf(['error'])
};

StyledFormItemInputVariants.defaultProps = {
  variant: undefined
};

export default {};
